import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
const DURATION_SECONDS = 17 * 60 + 34;
const START_TIME = Date.now();
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(getRemaining);
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const isDark = tone === 'dark';
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-88" data-mp="325szmhnhbw7y">
      <p className={`flex items-center gap-2 text-[12px] font-bold uppercase tracking-wider ${isDark ? 'text-white' : 'text-brand'}`} data-id="element-89" data-mp="373b9qbd8ghhj">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="15boh65dp0eiy" />
        This special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-91" data-mp="y04xe63v9qs3">
        <TimeBox value={hours} label="Hours" isDark={isDark} data-id="element-92" data-mp="t23g9qq041j9" />
        <Separator isDark={isDark} data-id="element-93" data-mp="t1k6ixai8jgb" />
        <TimeBox value={minutes} label="Minutes" isDark={isDark} data-id="element-94" data-mp="17qzuy6mkccsu" />
        <Separator isDark={isDark} data-id="element-95" data-mp="17q6luz04tb7j" />
        <TimeBox value={seconds} label="Seconds" isDark={isDark} data-id="element-96" data-mp="12s53kgaj5fx4" />
      </div>
    </div>;
}
function TimeBox({
  value,
  label,
  isDark
}: {
  value: number;
  label: string;
  isDark: boolean;
}) {
  return <div className="flex flex-col items-center" data-id="element-97" data-mp="a3hesaqko8et">
      <span className={`grid h-[68px] w-[68px] place-items-center rounded-xl font-serif text-[34px] font-extrabold tabular-nums sm:h-20 sm:w-20 sm:text-4xl ${isDark ? 'bg-white text-brand-dark' : 'bg-brand-dark text-white'}`} data-id="element-98" data-mp="a4sikak0pg5x">
        {String(value).padStart(2, '0')}
      </span>
      <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wide ${isDark ? 'text-white/70' : 'text-muted'}`} data-id="element-99" data-mp="1zk8q5liamttp">
        {label}
      </span>
    </div>;
}
function Separator({
  isDark
}: {
  isDark: boolean;
}) {
  return <span className={`pt-4 font-serif text-3xl font-bold sm:pt-5 ${isDark ? 'text-white' : 'text-brand-dark'}`} aria-hidden="true" data-id="element-100" data-mp="x485kxjji5yi">
      :
    </span>;
}
function getRemaining(): number {
  const elapsed = Math.floor((Date.now() - START_TIME) / 1000);
  return DURATION_SECONDS - elapsed % (DURATION_SECONDS + 1);
}